import React, { createContext, useContext, useState } from 'react';
import LoginBox from '../components/Auth/LoginBox';
import RegisterBox from '../components/Auth/RegisterBox';
import ForgotPasswordBox from '../components/Auth/ForgotPasswordBox';

const AuthModalContext = createContext();

export const useAuthModal = () => {
  const context = useContext(AuthModalContext);
  if (!context) {
    throw new Error('useAuthModal must be used within an AuthModalProvider');
  }
  return context;
};

export const AuthModalProvider = ({ children }) => {
  const [modalType, setModalType] = useState(null); // 'login', 'register', 'forgot'

  const openLogin = () => setModalType('login');
  const openRegister = () => setModalType('register');
  const openForgot = () => setModalType('forgot');
  const closeModal = () => setModalType(null);

  const renderModal = () => {
    if (!modalType) return null;

    return (
      <div 
        className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4"
      >
        <div 
          className="relative w-full max-w-sm"
          onClick={(e) => e.stopPropagation()}
        >
          {modalType === 'login' && (
            <LoginBox 
              onSuccess={closeModal} 
              onSwitchToRegister={openRegister}
              onSwitchToForgot={openForgot}
              showCloseBtn
              onClose={closeModal}
            />
          )}
          {modalType === 'register' && (
            <RegisterBox 
              onSuccess={openLogin} 
              onSwitchToLogin={openLogin}
              showCloseBtn
              onClose={closeModal}
            />
          )}
          {modalType === 'forgot' && (
            <ForgotPasswordBox 
              onSuccess={openLogin} 
              onSwitchToLogin={openLogin}
              showCloseBtn
              onClose={closeModal}
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <AuthModalContext.Provider value={{ openLogin, openRegister, openForgot, closeModal }}>
      {children}
      {renderModal()}
    </AuthModalContext.Provider>
  );
};
